(function() {
    'use strict';

    angular
        .module('app')
        .factory('RmRegistry', function() {
            var stack = [];
            return {
                push: function(vm) { stack.push(vm); },
                pop: function(vm) {
                    var i = stack.lastIndexOf(vm);
                    if (i >= 0) stack.splice(i, 1);
                },
                getParent: function(vm) {
                    var i = stack.lastIndexOf(vm);
                    return i > 0 ? stack[i - 1] : null;
                }
            };
        })
        .controller('Referencedmodelv2Controller', Referencedmodelv2Controller)

    Referencedmodelv2Controller.$inject = ["ContentService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "prefixCampos", "$scope", "RmRegistry"];

    function Referencedmodelv2Controller(ContentService, $http, $timeout, $uibModal, $log, $document, $sce, prefixCampos, scope, RmRegistry) {
 
        var vm = this;
        vm.contentServiceV = ContentService;

        vm.rowClass = "";
        vm.params = {
            idEdit: '',
            field: '',
            node_type: '',
            items: []
        }
        vm.modalContenido = "";
        vm.saveStatus = 'idle';
        vm.prefixCampos = prefixCampos;

        vm.htmlDecode = function(input) {
            var e = document.createElement('div');
            e.innerHTML = input;
            return e.childNodes[0].nodeValue;
        }

        vm.duplicarRef = function(item) {
            vm.params.items.push({ id: "", campos: angular.copy(item.campos), allowEdit: 0 });
        }

        vm.initItem = function(item) {
            if (item.id != "") {
                item.allowEdit = 1;
            }
        }

        vm.initPar = function(node_type, idEdit, field, field_id, fieldref_name) {
                vm.params.idEdit = idEdit;
                vm.params.field = field;
                vm.params.node_type = node_type;
                vm.params.actual_field_id = field_id;

                // Registrar en el stack global
                RmRegistry.push(vm);

                // Desregistrar cuando el scope se destruye
                scope.$on('$destroy', function() {
                    RmRegistry.pop(vm);
                });

                ContentService.getCamposModel(vm, function(data) {
                    vm.params.items = data.items;

                    var ctrlScope = scope.$parent;
                    while (ctrlScope && !ctrlScope.control) {
                        ctrlScope = ctrlScope.$parent;
                    }

                    if (ctrlScope && ctrlScope.control &&
                        angular.isDefined(ctrlScope.control.camposActual["_campo_" + fieldref_name + "_1"]) &&
                        ctrlScope.control.camposActual["_campo_" + fieldref_name + "_1"] != '') {
                        try {
                            var valueJson = JSON.parse(ctrlScope.control.camposActual["_campo_" + fieldref_name + "_1"]);
                            if (valueJson && valueJson.items && valueJson.items.length > 0) {
                                vm.params.items = valueJson.items;
                            }
                        } catch (e) {
                            console.error("Error parsing camposActual", e);
                        }
                    }
                });
            }

            function _ensureIdEdit(callback) {
            if (vm.params.idEdit && vm.params.idEdit !== '' && vm.params.idEdit !== '0') {
                callback();
                return;
            }

            var outerRmVm = RmRegistry.getParent(vm);

            if (outerRmVm) {
                // El idEdit del nivel 2 es el id del item del nivel 1
                // Si ya fue pre-guardado, reutilizarlo
                if (outerRmVm._preCreatedItemId) {
                    vm.params.idEdit = outerRmVm._preCreatedItemId;
                    callback();
                    return;
                }

                // Primero asegurar que el nivel 1 tiene su propio idEdit resuelto
                outerRmVm._ensureIdEdit(function() {
                    // Ahora guardar un item del nivel 1 con los campos actuales
                    // para obtener su id y usarlo como idEdit del nivel 2
                    var camposToSave = [];
                    for (var c = 0; c < outerRmVm.campos.length; c++) {
                        var campo = angular.copy(outerRmVm.campos[c]);
                        campo['value'] = {};
                        for (var c2 = 0; c2 < outerRmVm.languages.length; c2++) {
                            var langId = outerRmVm.languages[c2].id;
                            campo['value'][langId] = {
                                "value": outerRmVm.camposActual[outerRmVm.prefixCampos + campo["name"] + "_" + langId] || ''
                            };
                            if (!campo.multilang) { break; }
                        }
                        camposToSave.push(campo);
                    }

                    ContentService.saveOneItemRelModelv2(outerRmVm, { id: '', campos: camposToSave }, function(saveData) {
                        if (saveData && saveData.id) {
                            outerRmVm._preCreatedItemId = saveData.id;
                            vm.params.idEdit = saveData.id;
                        }
                        callback();
                    });
                });

            } else {
                // Buscar ContentController
                var contentCtrlVm = null;
                var s = scope;
                while (s) {
                    if (s.control && angular.isDefined(s.control.content_id)) {
                        contentCtrlVm = s.control;
                        break;
                    }
                    s = s.$parent;
                }

                if (contentCtrlVm) {
                    if (contentCtrlVm.content_id && contentCtrlVm.content_id !== '' && contentCtrlVm.content_id !== '0') {
                        vm.params.idEdit = contentCtrlVm.content_id;
                        callback();
                    } else {
                        ContentService.saveCampos(contentCtrlVm, function(savedData) {
                            vm.params.idEdit = savedData.content_id;
                            contentCtrlVm.content_id = savedData.content_id;
                            callback();
                        });
                    }
                } else {
                    var parentVm = scope.$parent && scope.$parent.control;
                    if (parentVm) {
                        if (parentVm.content_id && parentVm.content_id !== '' && parentVm.content_id !== '0') {
                            vm.params.idEdit = parentVm.content_id;
                            callback();
                        } else {
                            ContentService.saveCampos(parentVm, function(savedData) {
                                vm.params.idEdit = savedData.content_id;
                                parentVm.content_id = savedData.content_id;
                                callback();
                            });
                        }
                    } else {
                        callback();
                    }
                }
            }
        }

        vm._ensureIdEdit = _ensureIdEdit;

        vm.modalBorrar = "";
        vm.borrarItem = function(fieldName, item, index) {
            vm.modalBorrar = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                templateUrl: 'borrar_' + fieldName + '.html',
                size: 'lg',
                controller: function($scope) {
                    $scope.koForm = function() {
                        vm.modalBorrar.close();
                    }
                    $scope.okForm = function() {
                        vm.params.items.splice(index, 1);
                        vm.modalBorrar.close();
                    }
                }
            });
        }

        vm.initPopup = function(fieldName, id, nodetype, searchModel, editItem, index) {
            vm.type = nodetype;
            vm.params.node_type = nodetype;
            vm.lang_id_copy = 0;
            vm.duplicar = 0;
            vm.content_id = id;
            vm.lang_id = 1;
            vm.languages = [];
            vm.campos = [];
            vm.camposFinal = [];

            // Resolver idEdit antes de abrir el popup
            _ensureIdEdit(function() {
                ContentService.getCampos(vm, function(data) {
                    vm.languages = data.languages;
                    vm.campos = data.campos;
                    vm.camposHtml = data.html;
                    console.log("abriendo modal fieldName:", fieldName, "vm.params.idEdit:", vm.params.idEdit);

                    vm.modalContenido = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title-top',
                        ariaDescribedBy: 'modal-body-top',
                        templateUrl: 'content_' + fieldName + '.html',
                        size: 'lg',
                        scope: angular.extend(scope.$new(), { parentRmVm: vm }),
                        controller: function($scope) {
                            $scope.cc = vm;
                            $scope.camposHtml = vm.camposHtml;

                            $scope.cc.camposActual = {};
                            $scope.cc.opcionesextra = {};



                            if (typeof editItem !== 'undefined') {
                                for (var cont = 0; cont < editItem.campos.length; cont++) {
                                    for (var cont2 = 0; cont2 < data.languages.length; cont2++) {
                                        vm.camposActual[vm.prefixCampos + data.campos[cont]["name"] + "_" + data.languages[cont2].id] =
                                            angular.isDefined(editItem.campos[cont]["value"][data.languages[cont2].id])
                                                ? editItem.campos[cont]["value"][data.languages[cont2].id].value
                                                : '';
                                    }
                                }
                            }

                            $scope.koForm = function() {
                                vm.modalContenido.close();
                            }

                           $scope.okForm = function() {
                                for (var cont = 0; cont < vm.campos.length; cont++) {
                                    vm.campos[cont]['value'] = {};
                                    for (var cont2 = 0; cont2 < vm.languages.length; cont2++) {
                                        vm.campos[cont]['value'][vm.languages[cont2].id] = {
                                            "value": vm.camposActual[vm.prefixCampos + vm.campos[cont]["name"] + "_" + vm.languages[cont2].id]
                                        };
                                        if (!vm.campos[cont].multilang) { break; }
                                    }
                                }

                                ContentService.getValueCamposModel(vm, function(data) {
                                    if (editItem) {
                                        for (var i = 0; i < vm.params.items[index].campos.length; i++) {
                                            var existing = vm.params.items[index].campos[i];
                                            var updated = data.item.find(function(c) { return c.name === existing.name; });
                                            if (updated) {
                                                existing.value = updated.value;
                                                existing.valueshow = updated.valueshow;
                                            }
                                        }
                                        vm.params.items[index].allowEdit = 0;
                                        ContentService.saveOneItemRelModelv2(vm, { id: vm.params.items[index].id, campos: data.item }, function(saveData) {
                                            console.log("edit response", saveData);
                                        });

                                    } else if (vm._preCreatedItemId) {
                                        // El item ya fue creado por _ensureIdEdit de un hijo,
                                        // actualizarlo con los datos reales del formulario
                                        var preId = vm._preCreatedItemId;
                                        vm._preCreatedItemId = null;
                                        vm.params.items.push({ id: preId, campos: data.item, allowEdit: 0 });
                                        ContentService.saveOneItemRelModelv2(vm, { id: preId, campos: data.item }, function(saveData) {
                                            console.log("update pre-created response", saveData);
                                            ContentService.getCamposModel(vm, function(dataModel) {
                                                vm.params.items = dataModel.items;
                                            });
                                        });

                                    } else {
                                        // Item completamente nuevo
                                        vm.params.items.push({ id: '', campos: data.item, allowEdit: 0 });
                                        var newIndex = vm.params.items.length - 1;
                                        ContentService.saveOneItemRelModelv2(vm, { id: '', campos: data.item }, function(saveData) {
                                            console.log("new response", saveData);
                                            if (saveData && saveData.id) {
                                                vm.params.items[newIndex].id = saveData.id;
                                            }
                                            ContentService.getCamposModel(vm, function(dataModel) {
                                                vm.params.items = dataModel.items;
                                            });
                                        });
                                    }
                                });

                                vm.modalContenido.close();
                            };
                        }
                    });
                });
            });
        }

        vm.saveItemsRelModel = function(callback) {
            vm.saveStatus = 'saving';
            ContentService.saveItemsRelModelv2(vm, function(data) {
                console.log("saveItemsRelModel response", data);
                if (data && data.code == 1) {
                    vm.saveStatus = 'saved';
                    $timeout(function() { vm.saveStatus = 'idle'; }, 3000);
                } else {
                    vm.saveStatus = 'error';
                    $timeout(function() { vm.saveStatus = 'idle'; }, 4000);
                }
                if (typeof callback === 'function') {
                    callback(data);
                }
            });
        }

        var _saveItemTimers = {};
        var _saveItemPending = {};

        vm.saveSingleItem = function(item) {
            var itemId = item.id || JSON.stringify(item.campos.map(function(c) { return c.name; }));
            
            // Cancelar timer anterior del mismo item si existe
            if (_saveItemTimers[itemId]) {
                $timeout.cancel(_saveItemTimers[itemId]);
            }

            // Marcar como pendiente y mostrar estado
            _saveItemPending[itemId] = true;
            vm.saveStatus = 'pending';

            // Debounce de 800ms — si en ese tiempo llega otra llamada del mismo item, se cancela
            _saveItemTimers[itemId] = $timeout(function() {
                vm.saveStatus = 'saving';
                _saveItemPending[itemId] = false;

                ContentService.saveOneItemRelModelv2(vm, item, function(saveData) {
                    // Si mientras guardaba llegó otra petición del mismo item, ignorar respuesta
                    if (_saveItemPending[itemId]) {
                        return;
                    }
                    delete _saveItemTimers[itemId];

                    if (saveData && (saveData.code == 1 || saveData.id)) {
                        vm.saveStatus = 'saved';
                        $timeout(function() { vm.saveStatus = 'idle'; }, 3000);
                    } else {
                        vm.saveStatus = 'error';
                        $timeout(function() { vm.saveStatus = 'idle'; }, 4000);
                    }
                });
            }, 300);
        }
    }

})();